import { useQuery, useQueryClient } from "react-query";
import { supportWidgetApi } from "@circle-react/api/supportWidgetApi";
import {
  FIFTEEN_MINUTES,
  HELP_WIDGET_LOCATION_LOCAL_STORAGE_KEY,
} from "../constants";

const handleOnError = () => {
  localStorage.setItem(HELP_WIDGET_LOCATION_LOCAL_STORAGE_KEY, "/");
};

export const useShowNews = (id: string | number) => {
  const queryClient = useQueryClient();
  return useQuery(["news", id], () => supportWidgetApi.showPost(id), {
    onError: handleOnError,
    retry: false,
    staleTime: FIFTEEN_MINUTES,
    initialData: () =>
      queryClient
        .getQueryData<{ records: Array<{ id: number | string }> }>(["news"])
        ?.records?.find(d => d.id?.toString() === id),
  });
};
